import React, { Component } from 'react';
import Uuid from '../../../../../support/Uuid';

import RetencionesLocalesForm from './RetencionesLocalesForm';
import RetencionesLocalesList from './RetencionesLocalesList';

class RetencionesLocalesManager extends Component {
  state = {
    editing: undefined
  };

  handleOnAdd = (data) => {
    const { RetencionesLocales = [] } = this.props.data;

    const newData = [].concat(RetencionesLocales, [{
      id: Uuid.v4(),
      ...data
    }]);

    this.setState({
      editing: undefined
    });

    this.props.onChange({
      RetencionesLocales: newData
    });
  }

  handleOnEdit = (item) => {
    this.handleOnDelete(item);

    setTimeout(() => {
      this.setState({
        editing: item
      });
    }, 1);
  }

  handleOnDelete = (item) => {
    const { RetencionesLocales = [] } = this.props.data;

    const newData = RetencionesLocales.filter((value) => item.id !== value.id);

    this.props.onChange({
      RetencionesLocales: newData
    });
  }

  render() {
    const { data } = this.props;
    const { editing } = this.state;

    return (
      <fieldset>
        <legend className="text-muted">Retenciones Locales</legend>

        <RetencionesLocalesForm
          onAdd={ this.handleOnAdd }
          data={ editing }
        />

        <div className="py-2"></div>

        <RetencionesLocalesList
          data={ data.RetencionesLocales || [] }
          onEdit={ this.handleOnEdit }
          onDelete={ this.handleOnDelete }
        />
      </fieldset>
    )
  }
}

export default RetencionesLocalesManager;